import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RedirectCard from "../../components/RedirectCard";

export default function Redirect() {
  const request = useLocation().state?.request;
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!request) {
      navigate("/form");
      return;
    }

    // Set redirect timer
    timerRef.current = setTimeout(() => {
      window.location.href = "https://www.facebook.com/AATCExams/";
    }, 3000);

    // Cleanup timer on unmount
    return () => clearTimeout(timerRef.current);
  }, [request, navigate]);

  const cancelRedirect = () => {
    clearTimeout(timerRef.current);
    timerRef.current = null;
  };

  if (!request) return null;

  return (
    <div className="min-h-screen flex items-center justify-center">
      <RedirectCard request={request} onCancel={cancelRedirect} />
    </div>
  );
}
